import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {ApplicationScreenshot} from "../types.ts";
import {useApplicationScreenshot} from "../hooks/useApplicationScreenshot.ts";


export const AddFormDrawer = (props: DrawerProps) => {

    const {
        record,
        createRecord,
    } = useApplicationScreenshot();

    return (
        <FormDrawer
            record={record ?? {} as ApplicationScreenshot}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
